import moment from "moment";
import { profileImage } from "../../../assets";
import Button from "../../../component-lib/Molecules/button/Button";
import useDeviceType from "../../../custom-hooks/DeviceType";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import { formatPhoneNumber } from "../../../utils/phoneNumberFormatter";
import { Typography } from "@mui/material";
import EventEHRImageAvatar from "../../../component-lib/Atoms/image-avatar/EventEHRImageAvatar";

interface ViewPatientProfileProps {
  patientProfileData?: any;
  getProfileButtonClickEvent?: (data: any) => void;
  getCreateVisitButtonClickEvent?: (data: any) => void;
}

const ViewPatientProfile = ({
  patientProfileData,
  getProfileButtonClickEvent,
  getCreateVisitButtonClickEvent,
}: ViewPatientProfileProps) => {
  const deviceType = useDeviceType();

  const {
    firstName,
    lastName,
    gender,
    contactNumber,
    bsaId,
    baseCamp,
    dateOfBirth,
    profilePicture,
  } = patientProfileData;

  const patientInfoColumn1: Record<string, string> = {
    "First Name": firstName || "-",
    "BSA ID": bsaId || "-",
    "Contact Number": formatPhoneNumber(contactNumber) || "-",
    "Jamboree Unit Number": baseCamp?.unitNumber || "-",
  };

  const patientInfoColumn2: Record<string, string> = {
    "Last Name": lastName || "-",
    // DOB is date-only (midnight UTC) — render in UTC so it never shifts a day.
    "Date of Birth": moment.utc(dateOfBirth).format("MM/DD/YYYY") || "-",
    Gender: gender || "-",
    "Jamboree Unit Leader Name": baseCamp?.leaderName || "-",
  };

  const handleProfileButtonClickEvent = (patientProfileData: any) => {
    getProfileButtonClickEvent &&
      getProfileButtonClickEvent(patientProfileData);
  };

  const handleCreateVisitButtonClickEvent = (patientProfileData: any) => {
    getCreateVisitButtonClickEvent &&
      getCreateVisitButtonClickEvent(patientProfileData);
  };

  const fullname =
    firstName && lastName
      ? `${firstName[0].toUpperCase()} ${lastName[0].toUpperCase()}`
      : "NA";
  return (
    <div className="bg-neutral-10 p-4 gap-4 b-rad rounded-lg">
      <div
        className={`${deviceType === "mobile" ? "flex flex-col items-center" : "flex"} gap-5`}
      >
        <EventEHRImageAvatar
          image={profilePicture}
          commonStyle={{
            width: "70px",
            height: "70px",
            border: "2px solid #BCBCBC",
            borderRadius: "50%",
            overflow: "auto",
          }}
          customImageStyle={{
            borderRadius: "50%",
          }}
          labelText={fullname}
        />

        <div className="w-full flex p-3">
          <div className="w-[50%] flex flex-col gap-[14px]">
            {Object.keys(patientInfoColumn1).map((key: string, index) => {
              return (
                <div key={index} className="flex flex-col gap-2">
                  <p className="text-xs text-neutral-60">{key}</p>
                  <p className="text-sm font-normal">
                    {patientInfoColumn1[key]}
                  </p>
                </div>
              );
            })}
          </div>
          <div className="w-[50%] flex flex-col gap-[14px]">
            {Object.keys(patientInfoColumn2).map((key: string, index) => {
              return (
                <div key={index} className="flex flex-col gap-2">
                  <p className="text-xs text-neutral-60">{key}</p>
                  <p className="text-sm font-normal">
                    {patientInfoColumn2[key]}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex w-full pt-4 gap-4">
        {patientProfileData?.patient?.length !== 0 && (
          <Button
            label="View Profile"
            variant="outlined"
            onClickCb={() => {
              handleProfileButtonClickEvent(patientProfileData);
            }}
            style={{
              padding: "10px",
              width: "50%",
              backgroundColor: "white",
              border: "1px solid #D2D2D2",
              color: "#393939",
              fontSize: "16px",
              fontWeight: "500",
            }}
          ></Button>
        )}
        <Button
          label={TEXT_CONSTANTS?.CREATE_VISIT}
          variant="outlined"
          onClickCb={() => {
            handleCreateVisitButtonClickEvent(patientProfileData);
          }}
          style={{
            padding: "10px",
            width: patientProfileData?.patient?.length !== 0 ? "50%" : "100%",
            backgroundColor: "white",
            border: "1px solid #D2D2D2",
            color: "#393939",
            fontSize: "16px",
            fontWeight: "500",
          }}
        ></Button>
      </div>
    </div>
  );
};

export default ViewPatientProfile;
